import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1298.8238,9.99999997e-05 C1329.9948,9.99999997e-05 1355.2938,25.2991 1355.2938,56.4711 L1355.2938,56.4711 L1355.2938,112.9411 L1524.7058,112.9411 C1618.1088,112.9411 1694.1178,188.9511 1694.1178,282.3531 L1694.1178,282.3531 L1694.1178,1920.0001 L-0.0002,1920.0001 L-0.0002,282.3531 C-0.0002,188.9511 76.0088,112.9411 169.4118,112.9411 L169.4118,112.9411 L338.8228,112.9411 L338.8228,56.4711 C338.8228,25.2991 364.1228,9.99999997e-05 395.2938,9.99999997e-05 C426.4658,9.99999997e-05 451.7648,25.2991 451.7648,56.4711 L451.7648,56.4711 L451.7648,112.9411 L1242.3528,112.9411 L1242.3528,56.4711 C1242.3528,25.2991 1267.6518,9.99999997e-05 1298.8238,9.99999997e-05 Z M1581.1758,564.7051 L112.9418,564.7051 L112.9418,1807.0581 L1581.1758,1807.0581 L1581.1758,564.7051 Z M338.8228,225.8821 L169.4118,225.8821 C138.3528,225.8821 112.9418,251.1811 112.9418,282.3531 L112.9418,282.3531 L112.9418,451.7651 L1581.1758,451.7651 L1581.1758,282.3531 C1581.1758,251.1811 1555.7648,225.8821 1524.7058,225.8821 L1524.7058,225.8821 L1355.2938,225.8821 L1355.2938,282.3531 C1355.2938,313.5251 1329.9948,338.8241 1298.8238,338.8241 C1267.6518,338.8241 1242.3528,313.5251 1242.3528,282.3531 L1242.3528,282.3531 L1242.3528,225.8821 L451.7648,225.8821 L451.7648,282.3531 C451.7648,313.5251 426.4658,338.8241 395.2938,338.8241 C364.1228,338.8241 338.8228,313.5251 338.8228,282.3531 L338.8228,282.3531 L338.8228,225.8821 Z M846.5054,1416.6211 C764.1714,1416.6211 704.9904,1382.1741 652.1334,1320.7341 L561.3294,1404.0851 C623.5594,1479.0771 715.6064,1532.1601 844.4724,1532.1601 C998.7504,1532.1601 1103.3344,1435.3691 1103.3344,1300.9701 L1103.3344,1298.9361 C1103.3344,1164.5361 997.7334,1108.2921 885.8094,1094.7381 L1091.7014,886.4751 L1091.7014,790.5881 L602.5524,790.5881 L602.5524,902.0601 L922.6284,902.0601 L722.9474,1111.4541 L744.0674,1191.6421 L804.3784,1191.6421 C907.8324,1191.6421 974.4674,1232.1881 974.4674,1304.0181 L974.4674,1306.1651 C974.4674,1372.8001 919.4654,1416.6211 846.5054,1416.6211",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "translate(113)"
});

var IconCalendarDayLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCalendarDayLine, _Component);

  var _super = _createSuper(IconCalendarDayLine);

  function IconCalendarDayLine() {
    _classCallCheck(this, IconCalendarDayLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCalendarDayLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCalendarDay",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCalendarDayLine.displayName = "IconCalendarDayLine";
  return IconCalendarDayLine;
}(Component);

IconCalendarDayLine.glyphName = 'calendar-day';
IconCalendarDayLine.variant = 'Line';
IconCalendarDayLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCalendarDayLine;
export { IconCalendarDayLine };